// tabCentral
// v0.1

// requires JQuery

/*eslint no-unused-vars: ["error", {
    "varsIgnorePattern": "tabCentral"
}]*/

/*

Step 1: link JS and CSS files
    <link rel="stylesheet" type="text/css" href="styles/tab-central.css">
    <script type="text/javascript" src="js_inc/tab-central.js"></script>

Step 2: HTML
    Example:

    <div id="myDiv" class="tab-central">
        <div id="tab-one" label="Tab One">
            <p>One</p>
        </div>
        <div id="tab-two" label="Tab Two" class="tcShow">
            <p>Two<br>Two</p>
        </div>
        <div id="tab-three" label="Tab Three">
            <p>Three<br>Three<br>Three</p>
        </div>
    </div>

    tab-central class in root div required!
    ids and labels in tab divs required!

    tcShow class optional. Will show this tab on load if included. Will show
    first div if ommitted. If multiple divs have this class, it will show the
    last div found with this class. This
    feature is not compatible with Angular's ng-class.

    tcDisabled optional. Will disable this tab on load if included. This
    feature is not compatible with Angular's ng-class.

Step 3: Initiate
    Required: The target root div must be passed to tabCentral.init() as the first argument.
    This is so each tab group can have their own options.

    Examples:
        - tabCentral.init($("#myDiv")[0]);
        - tabCentral.init($("#myDiv")[0], { headerClass: "myHeaderClass" });
        - $.each($(".tab-central"), function(tabGrpIndx, tabGrp) { tabCentral.init(tabGrp) });

Options:
    You can pass options (object) as the second argument in tabCentral.init().

    In no particular order:
    {
        headerBarClass: "myheaderBarClass" // This class will be added to the header link bar.
        headerClass: "myHeaderClass" // This class will be added to all header buttons (tabs).
        activeHeaderClass: "myActiveHeaderClass" // This class will be added to the active header button (tab).
    }

*/

var tabCentral = {
    init: function(root, options) {
        'use strict';
        var stndOptions = { headerBarClass: "", headerClass: "", activeHeaderClass: "" },
            tabs = $(root).children("div:not(div.tab-central-header-bar)"),
            tabToShow = 0;
        if (options != undefined) {
            $.each(options, function(optKey, opt) { stndOptions[optKey] = opt; });
        }
        $(root).prepend("<div class='tab-central-header-bar " + stndOptions.headerBarClass + "'></div>");
        tabs.hide();
        $.each(tabs, function(tabIndx, tab) {
            $(root).children(".tab-central-header-bar").append("<button class='tab-central-header " + stndOptions.headerClass + "' for='" + $(tab).attr("id") + "'>" + $(tab).attr("label") + "</button>");
            if ($(tab).hasClass("tcDisabled")) {
                $($(root).children(".tab-central-header-bar").children(".tab-central-header")[tabIndx]).addClass("tab-central-disabled-header");
            } else if ($(tab).hasClass("tcShow")) tabToShow = tabIndx;
        });
        $($(root).find(".tab-central-header")[tabToShow]).addClass("tab-central-active-header " + options.activeHeaderClass);
        $(tabs[tabToShow]).show();
        $(".tab-central-header").click(function(){
            var theActiveTabHeader = $(this).parent().children(".tab-central-active-header"),
                theActiveTab = $("#" + theActiveTabHeader.attr("for")),
                theNewActiveTabHeader = $(this),
                theNewActiveTab = $("#" + theNewActiveTabHeader.attr("for")),
                allTabs = $(root).children("div:not(.tab-central-header-bar)");
            if (!theNewActiveTabHeader.hasClass("tab-central-disabled-header")) {
                theActiveTabHeader.removeClass("tab-central-active-header " + options.activeHeaderClass);
                theNewActiveTabHeader.addClass("tab-central-active-header " + options.activeHeaderClass);
                allTabs.css("opacity", 0);
                theActiveTab.slideUp(100);
                theNewActiveTab.slideDown(100, function() { allTabs.css("opacity", 1); });
            }
        });
    }
}
